// Дзеркало Prisma enum EntrySource. Походження запису розкладу.
// Значення ідентичні apps/api/prisma/schema.prisma (перевіряє test/enums.spec.ts). Підписи — лише тут.
export const EntrySource = {
    SOLVER: 'SOLVER',
    MANUAL: 'MANUAL',
    IMPORT: 'IMPORT',
};
/** Значення в порядку оголошення в схемі. */
export const ENTRY_SOURCE_VALUES = ['SOLVER', 'MANUAL', 'IMPORT'];
export const ENTRY_SOURCE_LABELS = {
    SOLVER: 'Генератор',
    MANUAL: 'Вручну',
    IMPORT: 'Імпорт',
};
//# sourceMappingURL=entry-source.js.map